import { cn } from '../lib/cn';

export const inputStyles = cn(
  'h-7 w-full min-w-0 rounded-md border border-border-strong bg-bg-2 px-2 text-sm text-text-1',
  'placeholder:text-text-4 transition-colors duration-100 outline-none',
  'hover:border-text-4 focus-visible:border-accent focus-visible:ring-2 focus-visible:ring-accent-subtle focus-visible:outline-none',
  'disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-status-critical',
  'read-only:border-border-subtle read-only:bg-transparent read-only:hover:border-border-subtle',
);
